import { CalendarMonth, Visibility, VisibilityOff } from "@mui/icons-material";
import dayjs from '../../../utils/dayjs-setup';
import { Button, Chip, Collapse, Dialog, DialogActions, DialogContent, GridLegacy as Grid, IconButton, List, ListItemText, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import React, { useEffect } from "react";
import { DateFormatString, FormatPrice } from "../../../utils/constants";





const TableRoute = ({
    routeNum=0,
    dataSet=[]
})=>{

    const [dataSetInternal,setDataSetInternal] = React.useState([]);

    useEffect(()=>{
       
        setDataSetInternal(dataSet);
    },[]);
    
    const onOpenRowItem = (index)=>{
        const newDataSet = [...dataSetInternal];
        newDataSet[index].isCollapse = newDataSet[index].isCollapse? false:true;
       setDataSetInternal(newDataSet);
    }
  
    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell></TableCell>
                    <TableCell>N°</TableCell>
                    <TableCell>Origen</TableCell>
                    <TableCell>Destino</TableCell>
                    <TableCell>Total kg</TableCell>
                    <TableCell>Total canastillas</TableCell>
                </TableRow>
              
            </TableHead>
            <TableBody>
                {
                    dataSetInternal?.map( (item,index)=><>
                 
                    <TableRow key={item.det_index} >
                        <TableCell><IconButton onClick={e=>onOpenRowItem( index )} >{!item.isCollapse?<Visibility />:<VisibilityOff/>}</IconButton> </TableCell>
                        <TableCell>N°{index+1} </TableCell>
                        <TableCell>{item.direccion || `${item.municipio_origen},${item.bodega_origen}`}</TableCell>
                        <TableCell>{item.municipio_destino}, {item.centro_op}</TableCell>
                        <TableCell>{item.total_kg} KG</TableCell>
                        <TableCell>{item.total_canastillas} CAN</TableCell>
                    </TableRow>
                    <TableRow>
                        
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                              <Collapse  in={item.isCollapse} timeout="auto" unmountOnExit >
                                <Grid container  >
                                    <Grid item xs={12} sm={12} md={12} >
                                        <Typography fontSize='18px' variant="h6" >
                                            Listado de productos
                                        </Typography>
                                    </Grid>
                                </Grid>
                                 <Grid item xs={12} sm={12} md={12}  >
                                             <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>
                                                            Cod Orden
                                                        </TableCell>
                                                        <TableCell>
                                                            Producto
                                                        </TableCell>
                                                        <TableCell>
                                                            Cantidad
                                                        </TableCell>
                                                        <TableCell>
                                                            Total Kg
                                                        </TableCell>
                                                        <TableCell>
                                                            Total Canastillas
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>

                                                        {item.list?.map( prod=>  <TableRow key={prod.cod_prod_prod} >
                                                        <TableCell>
                                                           CTZ-{prod.cod_orden_compra}
                                                        </TableCell>
                                                        <TableCell>
                                                           {prod.nombre_producto}
                                                        </TableCell>
                                                        <TableCell>
                                                        {prod.total_unidades_tranportar} {prod.un_comprada} 
                                                        </TableCell>
                                                        <TableCell>
                                                        {prod.total_ordenado_kg} KG
                                                        </TableCell>
                                                        <TableCell>
                                                           {prod.total_canastillas || 0} Canastillas
                                                        </TableCell>
                                                    </TableRow>)}
                                                  
                                                </TableBody>

                                             </Table>
                                          </Grid>
                                    
                                  
                                  
                                  
                              </Collapse>
                        </TableCell>
                  </TableRow>
                
                    </>
                  )
                }
            
            </TableBody>
        </Table>
    )

}

export const DetalleSolicitud = ({
    isOpened,
    onCloseModal=()=>{},
    data={},
    onLaunchSolicitud=()=>{}
})=>{




    return (
        <Dialog
        open={isOpened}
         maxWidth="md"
        >
            <DialogContent>
                <Grid container spacing={1} >
                    <Grid item xs={12} sm={12}  md={12} >
                        <Typography variant="h4" >
                            Solicitud # {data.cod}
                        </Typography>
                    </Grid>
                    <Grid item container spacing={1}  xs={12} sm={12} md={12} >
                        <Grid item xs={12} sm={12}  md={12} >
                            <Typography variant="h6" >
                              Datos basicos de la solicitud
                            </Typography>
                        </Grid>
                        <Grid item xs={6} sm={6}  md={6} >
                            <Stack direction={'row'} >
                            <CalendarMonth />  <Typography variant="p" ><strong>Fecha de recogida: </strong>{dayjs(data.fecha).format(DateFormatString)}</Typography>
                            </Stack>
                        </Grid>
                        <Grid item xs={6} sm={6}  md={6}  >
                        <Stack direction={'row'} >
                            <CalendarMonth />  <Typography variant="p" ><strong>Fecha de entrega: </strong>{dayjs(data.fecha_entrega_destino).format(DateFormatString)}</Typography>
                        </Stack>
                        </Grid>
                        <Grid item xs={12} sm={12}  md={12} >
                            <Typography variant="p" ><strong>Tipo de vehiculo: </strong>{data.tipo_vehiculo}</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6}  md={4} >
                            <Typography variant="p" >
                                    Total kilos: <Chip color="primary" label={FormatPrice(data.total_kg)} />
                            </Typography>
                        </Grid>
                        <Grid item xs={6} sm={6}  md={4} >
                            <Typography variant="p" >
                                    Total canastillas: <Chip color="secondary" label={FormatPrice(data.total_canastillas)} />
                            </Typography>
                        </Grid>
                        
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} >
                        <Typography variant="h6" >
                                Listado de rutas
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} >
                        <Button onClick={e=>onLaunchSolicitud(data)} size="small" variant="contained" >Lanzar solicitud</Button>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} >
                        <TableRoute dataSet={data.route_solicitud} routeNum={1} />
                    </Grid>
                
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCloseModal} variant="contained" color="secondary" >Cerrar ventana</Button>
            </DialogActions>
        </Dialog>
    )

}